import { Connection } from "./Connection.model"

export class SqlAadConnection extends Connection {
    public serverName!: string
    public database!: string
    public servicePrincipalId!: string
    public servicePrincipalPwd!: string
}